<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">


<div class="">
              


<div class="row lottery-transaction">
  <div class="col-lg-12">
    <div class="tabs-container">

    <ul class="nav nav-tabs">

        <li :class="{ active: tab_active.today }">
            <router-link :to="{name: 'transaction'}"  @click.native="toggleActive('today')" class="no-margins text-center"><i class="fa fa-list-ol"></i> รายการโพยล่าสุด</router-link>
        </li>
        <li :class="{ active: tab_active.history }" >
            <router-link :to="{name: 'transaction'}"  @click.native="toggleActive('history')" class="no-margins text-center text-nowrap"><i class="fa fa-history"></i> รายการโพยย้อนหลัง</router-link>
        </li>
        <li :class="{ active: tab_active.yeekee_today }">
            <router-link :to="{name: 'transaction'}"  @click.native="toggleActive('yeekee_today')" class="no-margins text-center"><i class="fa fa-list-ol"></i> รายการโพยจับยี่กี</router-link>
        </li>
        <li :class="{ active: tab_active.yeekee_history }" >
            <router-link :to="{name: 'transaction'}"  @click.native="toggleActive('yeekee_history')" class="no-margins text-center text-nowrap"><i class="fa fa-history"></i> รายการโพยจับยี่กีย้อนหลัง</router-link>
        </li>
        <li :class="{ active: tab_active.summary }">
        <router-link :to="{name: 'transaction'}" @click.native="toggleActive('summary')" class="no-margins text-center text-nowrap"><i class="fa fa-calendar-check-o"></i> สรุปยอดแทง</router-link>
        </li>

    </ul>

        <div class="tab-content" v-if="transaction_flag">
            <div class="tab-pane active">
                <div class="panel-body p-xs">
                    <div class="table-responsive">

                        <data-tables :data="orderhead" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="tableProps">
                          <el-table-column prop="oh_ordnum" label="เลขที่รายการ" width="180">
                              <template slot-scope="scope">
                                #{{scope.row.oh_ordnum}}
                              </template>
                          </el-table-column>
                          <el-table-column prop="description" label="งวดที่" width="auto" sortable="custom">
                          </el-table-column>
                          <el-table-column prop="date_time" label="วันที่ / เวลา" width="auto" sortable="custom">
                          </el-table-column>
                          <el-table-column prop="oh_total" label="เงินเดิมพัน" width="150" sortable="custom">
                              <template slot-scope="scope">
                                <div>{{ formatMoney(scope.row.oh_total) }} </div>
                              </template>
                          </el-table-column>
                          <el-table-column prop="lotto_result" label="ผลชนะ" width="150">
                              <template slot-scope="scope">
                                <div class="text-positive" v-if="scope.row.lotto_result > 0">{{ formatMoney(scope.row.lotto_result) }} </div>
                                <div v-else>{{ formatMoney(scope.row.lotto_result) }} </div>
                              </template>
                          </el-table-column>
                          <el-table-column prop="order_status" label="สถานะ" width="90" sortable="custom">
                              <template slot-scope="scope">
                                <div v-html="scope.row.order_status"></div>
                              </template>
                          </el-table-column>
                          <el-table-column prop="id" label="ดูโพย" width="90">
                            <template slot-scope="scope">
                                <button type="button" class="btn btn-xs btn-primary" @click="getTransaction(scope.row.id)"><i class="fa fa-list"></i> ดูโพย</button>
                            </template>
                          </el-table-column>
                          <el-table-column prop="cancel_order" label="คืนโพย" width="90">
                            <template slot-scope="scope">
                                <button type="button" class="btn btn-xs btn-danger btn-refund" @click="editTransaction(scope.row)" v-if="scope.row.cancel_status"><i class="fa fa-times" ></i> คืนโพย</button>
                            </template>
                          </el-table-column>
                        </data-tables>

                    </div>
                    <div class="text-right m-t-sm">
                      

                    </div>
                    <span class="text-primary-new">อัพเดตล่าสุด {{ lastUpdate }}</span>
                </div>
            </div>
        </div>

        <div class="tab-content" v-else>
            <div class="tab-pane active">
                <div class="panel-body p-xs">

                    <h3>{{ chartHeader }}</h3>
                      <GChart
                            type="BarChart"
                            :data="chartData['2']"
                            :options="chartOptions['2']"
                            :events="chartEvents"
                            ref="gChart"
                            v-if="chartData['2'].length > 0"
                        />

                      <GChart
                            type="BarChart"
                            :data="chartData['3']"
                            :options="chartOptions['3']"
                            :events="chartEvents"
                            ref="gChart"
                            v-if="chartData['3'].length > 0"
                        />

                      <GChart
                            type="BarChart"
                            :data="chartData['4']"
                            :options="chartOptions['4']"
                            :events="chartEvents"
                            ref="gChart"
                            v-if="chartData['4'].length > 0"
                        />
                </div>
            </div>
        </div>
        
    </div>



  </div>
</div>

            </div>


        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { GChart } from 'vue-google-charts'

export default {
    name: 'transaction',
    components: {
        GChart
    },
    data () {
        return {
            isHidden: false,
            completedFirstPass: false,
            okToLoadMore: false,
            query: {
                sort: '',
                order: 'desc',
                page: 0,
                limit: 5,
                type: 'lotto',
            },
            orderhead: [],
            lastUpdate: moment().format('DD/MM/YYYY HH:mm:ss'),
            tableProps: {
                border: true,
                stripe: true,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            itemWinPrice: {},
            tab_active: {
                today: true,
                history: false,
                yeekee_today: false,
                yeekee_history: false,
                summary: false,
            },
            transaction_flag: true,

            chartData: {
                2: [],
                3: [],
                4: [],
            },

            chartOptions: {
                2: { title: 'สรุปยอดแทงหวยรัฐบาล', bars: 'horizontal', },
                3: { title: 'สรุปยอดแทงหวยหุ้น', bars: 'horizontal', },
                4: { title: 'สรุปยอดแทงหวยยี่กี', bars: 'horizontal',  },
                // pieHole: 0.2,
            },
            chartHeader: '',

            chartEvents: {
                'select': () => {          
                    const chart = this.$refs.gChart.chartObject
                    console.log('chart', chart)  
                    const selection = chart.getSelection()
                    console.log('selection', selection)
                    // const onSelectionMeaasge = selection.length !== 0 ? 'row was selected' : 'row was diselected'
                    // alert(onSelectionMeaasge)

                    for (var i = 0; i < selection.length; i++) {
                        var item = selection[i]
                        console.log('str', item.row)
                    }


                },
                // 'click': () => {
                //     alert('click')
                // },
            },

        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            //orderhead: state => state.orderhead.orderhead,
        })
    },
    methods: {
        async loadTransaction () {

            if ( this.tab_active.today ) {
                this.query.type = 'today'
                this.chartHeader = 'สรุปยอดแทงในวันนี้'
            }
            else if ( this.tab_active.history ) {
                this.query.type = 'history'
                this.chartHeader = 'สรุปยอดแทงย้อนหลัง'
            }
            else if ( this.tab_active.yeekee_today ) {
                this.query.type = 'yeekee_today'
                this.chartHeader = 'สรุปยอดแทงในหวยยี่กีวันนี้'
            }
            else if ( this.tab_active.yeekee_history ) {
                this.query.type = 'yeekee_history'
                this.chartHeader = 'สรุปยอดแทงหวยยี่กีย้อนหลัง'
            }
            else if ( this.tab_active.summary ) {
                //nothing to do, use latest query
            }
            else {
                this.$toasted.error('Error, Not found route')
            }
            //console.log('async loadTransaction', this.query)

            try {
                const response = await this.$store.dispatch('orderhead/getUsersOrderhead', this.query)
                //console.log('async loadTransaction', response)

                for (let i = 0; i < response.itemData.length; i++) {
                    let item_line = response.itemData[i]
                    this.itemWinPrice[item_line.oh_id] = (item_line.total_win_price).toFixed(2)
                }

                this.orderhead = this.formatResultData(response.orderData)
                this.getNow()

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                if (this.completedFirstPass === false) { this.completedFirstPass = true }
            }
        },
        async editTransaction (ord) {

            if ( ord.status_id == 4 ) {

                let r = confirm('ยืนยันการคืนโพย? เมื่อคืนโพยแล้วสถานะโพยจะเป็นยกเลิกและคุณจะได้เงินคืน')
                if (r == true) {
                    //console.log('editTransaction', ord)

                    let in_period_status = 0

                    if ( ord.lottotype_id == 3 ) {
                        //console.log('country_id', ord.country_id)
                        this.checkIndexCancel(ord)
                        in_period_status = ord.in_period_status
                    }
                    else if ( ord.lottotype_id == 4 ) {
                        //yeekee
                        this.checkYeekeeCancel(ord)
                        in_period_status = ord.in_period_status
                        //console.log('in_period_status', in_period_status, ord['round_date'])
                    }
                    else {
                        //gov
                        in_period_status = moment().isBetween( moment(ord.start_date), moment(ord.expiration_date) )
                    }

                    //in_period_status = 0
                    if ( in_period_status ) {
                        await this.cancelOrder(ord)
                    }
                    else {
                        this.$toasted.error('Your Order couldn\'t be canceled. Out of time.')
                        this.$router.go(0)
                    }
                }

            }

        },

        async cancelOrder (ord) {
            let loader = this.$loading.show()
            try {

                let response = await this.$store.dispatch('orderhead/getOrderhead', ord.id)

                if ( response.status_id == 4 ) {

                    let cancel_data = {
                        id: ord.id,
                        round: ord.round,
                        lottotype_id: ord.lottotype_id,
                        round_date: ord.round_date,
                        oh_total: ord.oh_total,
                        oh_ordnum: ord.oh_ordnum,
                    }

                    await this.$store.dispatch('orderhead/cancelOrder', cancel_data)
                    this.$toasted.success('Order Canceled.')
                }
                else {
                    this.$toasted.error('ไม่สามารถคืนโพยได้ เนื่องจากโพยมีการเปลี่ยนแปลงสเตตัส')
                }
            } catch (error) {
                this.$toasted.error('Your Order couldn\'t be canceled. There was an error connecting to the server.')
            } finally {
                this.$router.go(0)
                this.$root.$emit('navbar')
                loader.hide()
            }
        },

        getTransaction (ordId) {
            //alert(ordId)
            this.$router.push({name: 'getTransaction', query: {orderId: ordId}})
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },
        getNow () {
            this.lastUpdate = moment().format('DD/MM/YYYY HH:mm:ss')
        },

        toggleActive (tabIndex) {
            
            for ( let key in this.tab_active ){
                // this.tab_active[key] = !this.tab_active[key]
                if ( key === tabIndex ) {
                    this.tab_active[key] = true
                }
                else {
                    this.tab_active[key] = false
                }
            }

            if ( tabIndex == 'summary' ) {
                this.transaction_flag = false
                this.prepareSummaryData()
            }
            else {
                this.transaction_flag = true
            }

            this.loadTransaction()
        },

        prepareSummaryData() {

            let order_summary = {}
            for (let i = 0; i < this.orderhead.length; i++) {
                let lottotype_id = this.orderhead[i].lottotype_id
                let status_id = this.orderhead[i].status_id
                let order_id = this.orderhead[i].id

                if ( status_id > 3 ) {

                    if ( !order_summary[lottotype_id] ) {
                        order_summary[lottotype_id] = {}

                        order_summary[lottotype_id]['win_total'] = 0

                        if ( this.itemWinPrice[order_id] ) {
                            order_summary[lottotype_id]['win_total'] += parseFloat( this.itemWinPrice[order_id] || 0 )
                        }

                        if ( !order_summary[lottotype_id][status_id] ){
                            order_summary[lottotype_id][status_id] = parseFloat(this.orderhead[i].oh_total)
                        }
                        else {
                            order_summary[lottotype_id][status_id] += parseFloat(this.orderhead[i].oh_total)
                        }

                    }
                    else {

                        if ( this.itemWinPrice[order_id] ) {
                            order_summary[lottotype_id]['win_total'] += parseFloat( this.itemWinPrice[order_id] || 0 )
                        }

                        if ( !order_summary[lottotype_id][status_id] ){
                            order_summary[lottotype_id][status_id] = parseFloat(this.orderhead[i].oh_total)
                        }
                        else {
                            order_summary[lottotype_id][status_id] += parseFloat(this.orderhead[i].oh_total)
                        }
                    }

                }
                
            }
            // console.log('order_summary', order_summary)
            // console.log('chartData', this.chartData)

            let type_mapping = {
                2: 'หวยรัฐบาล',   
                3: 'หวยหุ้น',
                4: 'หวยยี่กี',
            }

            this.chartData = {
                2: [],
                3: [],
                4: [],
            }

            for ( let key in order_summary ){
                //this.chartData[key].push( ['สถานะ', 'จำนวนเงินทั้งหมด', ] )
                this.chartData[key].push( ['ประเภทหวย', 'ยอดที่ยังไม่ออกผล', 'ยอดแทงทั้งหมดที่ออกผลแล้ว', 'ยอดถูกรางวัลทั้งหมด', 'กำไร', 'ขาดทุน' ] )

                let order_status = order_summary[key]

                let bet_total = parseFloat(order_status[5] || 0) + parseFloat(order_status[6] || 0)
                let win_total = order_status['win_total']

                let profit_total = 0, lost_total = 0

                if ( bet_total > win_total ) {
                    lost_total =  bet_total - win_total
                }
                else if ( bet_total < win_total ) {
                    profit_total =  win_total - bet_total
                }

                this.chartData[key].push( [ type_mapping[key], parseFloat(order_status[4] || 0), bet_total, win_total, profit_total, lost_total ] )

            }
            // console.log('chartData', this.chartData)
            // console.log('itemWinPrice', this.itemWinPrice)

        },

        getOrderStatus (status) {
            //console.log('status', status)
            let msgStatus = ''
            if ( status == '3' ) {
                //cancel
                msgStatus = '<span class="label label-danger">ยกเลิก</span>'
            }
            else if ( status == '4' ) {
                //complete
                msgStatus = '<span class="label label-success">รับแทง</span>'
            }
            else if ( status == '5' ) {
                //paid
                msgStatus = '<span class="label label-info">ออกผล</span>'
            }
            else if ( status == '6' ) {
                //close
                msgStatus = '<span class="label label-info">ออกผล</span>'
            }
            return msgStatus
        },

        async getItemWinPrice (order) {
            //console.log('getItemWinPrice', order)

            if ( order.status_id > 4 ) {

                try {
                    //console.log('order id:', this.$route.query.orderId)
                    const response = await this.$store.dispatch('orderitem/getOrderitem', order.id)
                    //console.log('response: ', response)
                    if ( response.length > 0 ) {
                        let all_win_rate = 0 
                        for (let i = 0; i < response.length; i++) {
                            if ( response[i].oi_win ) {
                                all_win_rate = parseFloat(all_win_rate) + parseFloat(response[i].win_price)
                            }
                        }
                        //console.log('getItemWinPrice', all_win_rate)
                        this.itemWinPrice[order.id] = all_win_rate.toFixed(2)
                    }
                    
                } catch (error) {
                    this.$toasted.error('There was an error connecting to the server.')
                }

            }
            else {
                this.itemWinPrice[order.id] = 0
            }
        },

        formatResultData (raw_data) {

            for (let i = 0; i < raw_data.length; i++) {

                raw_data[i].date_time = this.formatDate(raw_data[i].created_at)
                raw_data[i].lotto_result = 0
                raw_data[i].order_status = this.getOrderStatus(raw_data[i].status_id)
                raw_data[i].oh_total = (raw_data[i].oh_total).toFixed(2)

                // waiting order, order cannot cancel
                raw_data[i].in_period_status = 0
                if ( raw_data[i].status_id == '4'  ) {
                    if ( raw_data[i].lottotype_id === 3 ) {
                        //indexes
                        this.checkIndexCancel(raw_data[i])
                    }
                    else if ( raw_data[i].lottotype_id === 4 ) {
                        //yeekee
                        this.checkYeekeeCancel(raw_data[i])
                        //console.log('in_period_status', in_period_status, ord['round_date'])
                    }
                    else {
                        raw_data[i].in_period_status = moment().isBetween( moment(raw_data[i].start_date), moment(raw_data[i].expiration_date) )
                    }
                }

                raw_data[i].lotto_result = this.itemWinPrice[raw_data[i].id] || 0
                raw_data[i].cancel_status    = raw_data[i].in_period_status && raw_data[i].status_id === 4

            }
            //console.log('raw_data', raw_data, this.itemWinPrice)
            return raw_data
        },

        checkIndexCancel (data) {

            data.in_period_status = 0
            //let LOTTO_ROUND = data.round
            let LOTTO_ROUND = data.round

            let startTime = moment(data.start_date).format('HH.mm')
            let [shh, smm] = startTime.split('.')

            let start_time = moment().hour(shh).minute(smm).second(0) // open time

            let endTime = moment(data.expiration_date).format('HH.mm')
            let [ehh, emm] = endTime.split('.')

            data['round_date'] = moment().format('YYYY-MM-DD')


            //check fix round
            if ( LOTTO_ROUND == '1' ) {
                // USA
                if ( moment().isBefore(start_time) ) {
                    // current time is 00.01 - 17.29 < 17.30
                    data.end_time = moment().hour(ehh).minute(emm).second(0)

                }
                else {
                    //current time is 17.31 - 23.59 > 01.00
                    let tomorrow = moment().add(1, 'days')
                    data.end_time = moment(tomorrow).hour(ehh).minute(emm).second(0)
                }

                if ( moment().isBefore(start_time) ) {

                    let yesterday = moment().subtract(1, 'days')
                    data['round_date'] = moment(yesterday).format('YYYY-MM-DD')
                }


            }
            else if ( LOTTO_ROUND == '25' || LOTTO_ROUND == '26' ) {
                data['round_date'] = moment(data.expiration_date).format('YYYY-MM-DD')
                data.end_time = moment(data.expiration_date)
            }
            else {

                let current_day = moment()
                let created_day = moment(data.created_at)
                if ( current_day.isSame(created_day, 'day')  ) {
                    // Same day - maybe different times
                    data.end_time = moment().hour(ehh).minute(emm).second(0)

                } else {
                    // Different day
                    return data
                }

            }

            if ( moment().isBefore(data.end_time) ) {
                // not endtime yet
                data.in_period_status = 1
            }

            // console.log('current', this.formatDate(curr_time), this.formatDate(data.end_time), data.description)
            // console.log('data', data)
            return data
        },

        checkYeekeeCancel (data) {

            data.in_period_status = 0
            let LOTTO_ROUND = data.round

            //get end time
            let endTime = moment(data.expiration_date).format('HH.mm')
            let [ehh, emm] = endTime.split('.')

            let start_time = moment().hour(5).minute(0).second(0) // open time

            if ( moment().isBefore(start_time) ) {
                // current time is 00.01 - 04.59 < 05.00
                let yesterday = moment().subtract(1, 'days')
                let yesterday_end = moment(yesterday).hour(ehh).minute(emm).second(0)
                let cancel_end = moment(yesterday_end).subtract(1, 'seconds')


                if ( LOTTO_ROUND > 73 ) {
                    //bet in today, cancel date is today
                    let today_end = moment().hour(ehh).minute(emm).second(0)
                    cancel_end = moment(today_end).subtract(1, 'seconds')
                }

                if ( moment().isBefore(cancel_end) ) {
                    // not endtime yet
                    data.in_period_status = 1
                    // set round date to yesterday
                    data['round_date'] = moment(yesterday).format('YYYY-MM-DD')
                }

            }
            else {
                //current time is 05.01 - 23.59 > 05.00
                let today = moment().hour(ehh).minute(emm).second(0)
                let cancel_end = moment(today).subtract(1, 'seconds')

                // if ( LOTTO_ROUND > 73 ) {

                //     //bet in advance, cancel date must be tomorrow
                //     let tomorrow = moment().add(1, 'days')
                //     let tomorrow_end = moment(tomorrow).hour(ehh).minute(emm).second(0)
                //     cancel_end = moment(tomorrow_end).subtract(1, 'seconds')
                // }

                // if ( moment().isBefore(cancel_end) ) {
                //     // not endtime yet
                //     data.in_period_status = 1
                //     // set round date in current day, (bet in advance)
                //     data['round_date'] = moment().format('YYYY-MM-DD')
                // }


                if ( moment(data.created_at).isAfter(start_time) ) {
                    // console.log('order place today')

                    if ( LOTTO_ROUND > 73 ) {

                        //bet in advance, cancel date must be tomorrow
                        let tomorrow = moment().add(1, 'days')
                        let tomorrow_end = moment(tomorrow).hour(ehh).minute(emm).second(0)
                        cancel_end = moment(tomorrow_end).subtract(1, 'seconds')
                    }

                    if ( moment().isBefore(cancel_end) ) {
                        // not endtime yet
                        data.in_period_status = 1
                        // set round date in current day, (bet in advance)
                        data['round_date'] = moment().format('YYYY-MM-DD')
                    }

                }
                // else {
                //     console.log('order place before today')
                // }

            }

            return data
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

    },
    mounted () {
    },
    created () {
        this.loadTransaction()
        //console.log('orderhead', this.orderhead)
    },
    destroyed () {
    }
}
</script>

<style scoped>

.nav>li.active {
    border-left: none !important;
    /* background: #dc11d5; */
}

</style>

